const ELEMENTS_IN_USE = {
    element: '.js--mac-device',
};

export default function macDevice() {
    if (navigator.userAgent.indexOf('Mac') > 0) {
        const elements = document.querySelectorAll(ELEMENTS_IN_USE.element);

        if (elements.length > 0) {
            elements.forEach((element) => {
                element.classList.add('is-mac');
            });
        }
    }
}
